// extracted by mini-css-extract-plugin
export var searchHeader = "_3f-0";
export var searchHeaderDark = "_3f-1";